// Arabic strings for the deploy stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enDeploy } from './en-deploy.ts';
import type { Message } from './types.ts';

export const arDeploy: { readonly [K in keyof typeof enDeploy]: Message } = {
  // ------------------------------------------------------------ deployment profile (PD-663)
  'ops.pid.uae-pilot': 'التجربة الأولى في الإمارات (passage.scinops.com)',
};
